import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Error404 from 'components/errors/404'
import { mapLanguageToComponentProps } from 'interview/i18n'
import { Header } from 'components/styled/header'
import { PageContent } from 'components/styled/page/page-content'

/**
 * Render container for the page
 */

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  i18n: PropTypes.shape({
    layout: PropTypes.object,
  }).isRequired,
  httpError: PropTypes.number,
}

const defaultProps = {
  children: undefined,
  httpError: undefined,
}

export function GenericLayout(props) {
  const { children, httpError } = props

  return (
    <>
      {httpError === 404 ? (
        <Error404 />
      ) : (
        <div>
          <Header />
          <PageContent size="small">{children}</PageContent>
        </div>
      )}
    </>
  )
}

GenericLayout.propTypes = propTypes
GenericLayout.defaultProps = defaultProps

export default connect(
  mapLanguageToComponentProps(state => ({
    jobOpening: state.interview.jobOpening,
    httpError: state.global.httpError,
  }))
)(GenericLayout)
